import { Info } from "lucide-react";
import { createIcon } from "@/components/icons/create-icon";

export const InfoIcon = createIcon(Info);
